import { atom } from "recoil";

export const chatPinnedEditModalStore = atom({
	key: "chatPinnedEditModalStore",
	default: {
		show: false,
		loaded: true,
		currentOption: {
			status: [
				{ value: "enabled", label: "Enabled" },
				{ value: "disabled", label: "Disabled" },
			],
			type: [
				{ value: "permanent", label: "Permanent" },
				{ value: "interval", label: "Interval" },
			],
			messageType: [
				{ value: "local", label: "Local" },
				{ value: "international", label: "International" },
				{ value: "mixed", label: "Mixed" },
			],
		},
		id: false,
		message: "",
		messageType: "",
		isClickable: false,
		link: "",
		lastDisplayedDate: null,
		lastDisplayedTime: null,
		type: false,
		status: false,
		durationMinutes: 0,
		intervalMinutes: 0,
	},
});
